import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Image from "../../elements/image";
import BasicModal from "../../elements/basic-modal";
import PrimaryButton from "../../elements/primary-button";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";

const HeroCard = ({ heading, label, learnMoreTitle, modalContent, backgroundImage, modalProps }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const modalClassNames = classNames("card-modal", `${isModalOpen ? "show" : "hide"}-basic-modal`);

  useEffect(() => {
    return function cleanup() {
      document.body.classList.remove("show-modal");
    };
  });

  return (
    <>
      <div
        className="card__content"
        onClick={() => {
          setIsModalOpen(true);
          document.body.classList.add("show-modal");
        }}
      >
        <Image {...backgroundImage}></Image>
        <div className="card__overlay"></div>
        <div className="card__overlay-content">
          <span className="card__learn-more-title">{learnMoreTitle}</span>
        </div>
        <div className="card__bottom-row">
          <div className="card__title-wrapper">
            <span className="card__label">{label}</span>
            <span className="card__heading">{heading}</span>
          </div>
        </div>
      </div>

      <BasicModal
        {...modalProps}
        onCloseClicked={() => {
          setIsModalOpen(false);
          document.body.classList.remove("show-modal");
        }}
        className={modalClassNames}
      >
        <div className="card-modal__content">
          <div className="card-modal__grid">
            <div className="card-modal__image-wrapper">
              <Image className="card-modal__image" {...modalContent.heroImage}></Image>
            </div>
            <div className="card-modal__text-wrapper">
              <span className="card-modal__overline">{modalContent.heroName}</span>
              <Heading {...modalContent.heroTitle} className="card-modal__heading" />
              <BodyText className="card-modal__preview" html={modalContent.heroPreview} />
              <div className="card-modal__button">
                <PrimaryButton {...modalContent.heroLink} />
              </div>
            </div>
          </div>
        </div>
      </BasicModal>
    </>
  );
};

HeroCard.propTypes = {
  heading: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  learnMoreTitle: PropTypes.string.isRequired,
  modalContent: PropTypes.object,
  backgroundImage: PropTypes.object,
  modalProps: PropTypes.shape({
    withShadow: PropTypes.bool,
    screenSettings: PropTypes.shape({
      fullWidth: PropTypes.bool,
      fullScreen: PropTypes.bool,
      fullHeight: PropTypes.bool
    })
  })
};

HeroCard.defaultProps = {
  modalProps: {
    withShadow: true,
    screenSettings: {
      fullWidth: false,
      fullScreen: false,
      fullHeight: false
    }
  }
};

export default HeroCard;
